import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

export const createLead = async (payload) => {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
};

export const subscribeEmail = async (email) => {
  const { data } = await axios.post(`${API}/subscribe`, { email });
  return data;
};
